// ============================================================================
// RED-BLACK TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'red-black-tree',
  name: 'Red-Black Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A self-balancing binary search tree with extra color bits (red/black) on each node. Maintains balance through color rules and rotations, guaranteeing O(log N) operations and used in many standard library implementations.'
};
